import axios from "@/api/axiosInstance";
import {
  FetchMyTrainingHistoryParams,
  FetchMyTrainingHistoryResponse,
} from "./types";

export const fetchMyTrainingHistory = async (
  params: FetchMyTrainingHistoryParams = {},
): Promise<FetchMyTrainingHistoryResponse> => {
  const response = await axios.get<FetchMyTrainingHistoryResponse>(
    "/api/private/my/training-history",
    { params },
  );
  return response.data;
};
